import { render, staticRenderFns } from "./ModalDetailPengajuanMitra.vue?vue&type=template&id=52cabf0e&"
import script from "./ModalDetailPengajuanMitra.vue?vue&type=script&lang=js&"
export * from "./ModalDetailPengajuanMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports